const APP_VERSION = '1777490808781';
export default APP_VERSION;
